import React, { FC } from 'react'
import { Accordion } from '@wmgtech/legato'
import { IAccordionProps } from '@wmgtech/legato/build/components/Accordion/Accordion'

import styles from './AccordionInfo.module.scss'

const AccordionInfoContainer: FC<IAccordionProps> = (props) => (
  <Accordion {...props} className={styles.container} />
)

export default AccordionInfoContainer
